import { format } from 'date-fns';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetWorkforceResourcesCrews } from '@/modules/home/apiHooks';
import { workforceResourcesCrewsColumns } from '@/modules/home/components/PageContent/WorkforceSections/logic';
import { useHomePageContext } from '@/modules/home/context';
import { Table } from '@/shared/components/atoms';
import { EmptyCard } from '@/shared/components/molecules';
import { useStore } from '@/shared/hooks/context/createGenericContext';

import Group from '~/images/shared/groupPerson.svg';

const WorkforceResourcesCrews = () => {
  const { t } = useTranslation('common');
  const [selectedAsset] = useStore((store) => store?.asset);
  const { data, mutate } = useGetWorkforceResourcesCrews();
  const {
    state: { date },
  } = useHomePageContext();

  useEffect(() => {
    if (selectedAsset?.id && date) {
      mutate({
        entityId: selectedAsset.id,
        date: format(date, 'yyyy-MM-dd'),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAsset?.id, date]);

  // TODO: pagination scroll
  return data?.length ? (
    <Table
      selection={false}
      headerClassName='sticky'
      headCellClassName='text-start [&>div]:text-14 border-b-xs border-neutralVariant-90 text-surface-10'
      headContainerClassName='!bg-background-neutral-99'
      tableClassName='!border-collapse'
      rowContainerClassName='!bg-background-transparent last-of-type:border-b-0 border-neutralVariant-90 border-b-xs'
      columns={workforceResourcesCrewsColumns(t)}
      data={data}
      pagination={false}
    />
  ) : (
    <EmptyCard
      directiveMessage={t('add-crews-from-app')}
      message={t('no-crews')}
      vector={
        <span className='text-40 text-primary-60'>
          {/* TODO: fix farmer color */}
          <Group />
        </span>
      }
      variant='icon'
      classeName='my-40'
    />
  );
};
export { WorkforceResourcesCrews };
